import script from "./ShadowType.vue?vue&type=script&setup=true&lang=ts"
export * from "./ShadowType.vue?vue&type=script&setup=true&lang=ts"

import "./ShadowType.scss?vue&type=style&index=0&id=0d29f2b9&scoped=true&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0d29f2b9"]])

export default __exports__